import React, { useState, useEffect, useContext } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import { MLRiskAnalysisService } from 'ml-services-common-react';
import { UserService } from 'gw-capability-gateway';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { DateValue, CurrencyValue, useModal } from '@jutro/components';

import metadata from './MLRatingFactorCompanyUseComponent.metadata.json5';
import messages from './MLRatingFactorCompanyUseComponent.messages.js';

import MLRatingFactorCompanyUseClaimDetailsPopupMetadata from './MLRatingFactorCompanyUseClaimDetailsPopup.metadata.json5';

const MLRatingFactorCompanyUseComponent = (props) => {
    const modalApi = useModal();
    const { jobOrPolicyNumber, isQuote, isPolicy, isPersonalAuto, isPersonalUmbrella, isHomeOwners, styles, authHeader, viewModelService, isModernProduct } = props;

    const BOOKROLLINDICATOR_TYPELIST = viewModelService.productMetadata.get('pc').types.getTypelist('BookrollIndicator_Ext');
    const CAPPINGTYPE_TYPELIST = viewModelService.productMetadata.get('pc').types.getTypelist('CappingType_ML');
    const PERILCAPPED_TYPELIST = viewModelService.productMetadata.get('pc').types.getTypelist('PerilCapped_ML');

    const translator = useTranslator();

    const [losses, setLosses] = useState([]);
    const [serviceLevelInfo, setServiceLevelInfo] = useState({});
    const [rateCappingDetails, setRateCappingDetails] = useState({});
    const [bookRollInd, setBookRollInd] = useState();
    const [garagingLocations, setGaragingLocations] = useState([]);
    const [signalRecords, setSignalRecords] = useState([]);
    const [connectedCar, setConnectedCar] = useState([]);
    const [vehicleSymbols, setVehicleSymbols] = useState([]);
    const [violations, setViolations] = useState([]);
    const [veracityUrl, setVeracityUrl] = useState();
    const [locationInfo, setLocationInfo] = useState({});
    const [hazardInfo, setHazardInfo] = useState({});
    const [riskEligibilityInfo, setRiskEligibilityInfo] = useState({});
    const [fireSubscriptionIndicator, setFireSubscriptionIndicator] = useState();
    const [coastalFloodingInfo, setCoastalFloodingInfo] = useState({});
    const [perilScoreInfo, setPerilScoreInfo] = useState({});
    const [primaryResidences, setPrimaryResidences] = useState([]);
    const [isGCSServicing, setIsGCSServicing] = useState(false);
    const [vehicleSymbolsNP,setVehicleSymbolsNP]= useState([]);
    const [isModernProductAuto,setIsModernProduct]=useState(false)
    const isModernProductPersonalAuto = isModernProduct && isPersonalAuto

    const getYesNo = (value) => {
        if (value === true) {
            return platformMessages.mlYes;
        }
        return platformMessages.mlNo;
    }

    const getTypeKeyDescription = (typeKeyName) => {
        return translator({
            id: typeKeyName,
            defaultMessage: typeKeyName
        });
    };

    const updateCompanyUse = (data) => {
        setServiceLevelInfo(data.serviceLevelInfo);
        setRateCappingDetails(data.rateCappingDetails);
        setBookRollInd(data.bookRollInd);
        if (data.lobs) {
            if (isPersonalAuto) {
                setLosses(data.lobs.personalAuto.chargeableIncidents.losses);
                setGaragingLocations(data.lobs.personalAuto.garagingLocations);
                setVehicleSymbols(data.lobs.personalAuto.vehicleSymbols);


const mappedVehicleSymbolsNP =
 data?.lobs?.personalAuto?.vehicleSymbols?.map((veh, index) => {
    const v = veh?.vehicle || veh?.Vehicle || {};
    const model = String(v.model ?? v.Model ?? "").trim().toLowerCase();
 
    const title =
      `${v.year ?? v.Year ?? ""} ${v.make ?? v.Make ?? ""} ${v.model ?? v.Model ?? ""}`.trim();

    const symb = (x) => (x === undefined || x === null ? "" : String(x).trim());
    const hasVal = (x) => {
      const s = symb(x);
      return s !== "" && s !== "0";
    };
 
    const yesOrNoOrBlank = (x) => {
      if (x === undefined || x === null || x === "") return "";
      return x ? "Yes" : "No";
    };
 
    const LABEL = 14;
    const VALUE = 8;
    const GAP = "        ";
 
    const col = (label, value) =>
      label.padEnd(LABEL, " ") + " " + symb(value).padEnd(VALUE, " ");
 
    //------ Always show labels---------------
    const highPerfVal = yesOrNoOrBlank(v.highPerfInd ?? v.HighPerfInd);
    const luxuryVal = yesOrNoOrBlank(v.luxuryCarInd ?? v.LuxuryCarInd);
 
    const checkboxLine =
      col("High Performance", highPerfVal) + GAP +
      col("Luxury Car", luxuryVal);
 
    const carSymbols = veh?.carSymbols || veh?.CarSymbols || [];
    const symbolPairs = carSymbols
      .map((s) => ({
        cov: symb(s?.coverageCd ?? s?.CoverageCd),
        val: symb(s?.symbolCd ?? s?.SymbolCd),
      }))
      .filter((p) => p.cov && hasVal(p.val));
 
    const hasAnything = symbolPairs.length > 0 || true; 
    if (!hasAnything) return { id: `vehicle-${index}`, title, content: "" };
 
    const rows = [];
    for (let i = 0; i < symbolPairs.length; i += 3) {
      const a = symbolPairs[i];
      const b = symbolPairs[i + 1];
      const c = symbolPairs[i + 2];
 
      const line =
        col(a.cov, a.val) + GAP +
        (b ? col(b.cov, b.val) : "".padEnd(LABEL + 1 + VALUE, " ")) + GAP +
        (c ? col(c.cov, c.val) : "");
 
      rows.push(line.trimEnd());
    }
 
    const content = ["", ...rows, checkboxLine].join("\n");
 
    return {
      id: `vehicle-${index}`,
      title,
      content,
    };
  }) || [];
 
                setVehicleSymbolsNP(mappedVehicleSymbolsNP);
                setVehicleSymbolsNP(mappedVehicleSymbolsNP);
                setIsModernProduct(data.lobs.personalAuto.vehicleSymbols[0]?.isModernProduct_Ext)
                setViolations(data.lobs.personalAuto.chargeableIncidents.violations);
                setVeracityUrl(data.lobs.personalAuto.veracityIdFusionUrl);
                setSignalRecords(data.lobs.personalAuto.signalRecords);
                //setConnectedCar(data.lobs.personalAuto.connectedCar);
            } else if (isHomeOwners) {
                setLosses(data.lobs.homeowners.chargeableIncidents.losses);
                setLocationInfo(data.lobs.homeowners.locationInfo);
                setHazardInfo(data.lobs.homeowners.hazardInfo);
                setRiskEligibilityInfo(data.lobs.homeowners.riskEligibilityInfo);
                setFireSubscriptionIndicator(hazardInfo.fireSubscriptionIndicator === 'Y' ? 'Yes' : '');
                setCoastalFloodingInfo(data.lobs.homeowners.coastalFloodingInfo);
                setPerilScoreInfo(data.lobs.homeowners.perilScoreInfo);
            } else if (isPersonalUmbrella) {
                setLosses(data.lobs.personalUmbrella.chargeableIncidents.losses);
                setPrimaryResidences(data.lobs.personalUmbrella.primaryResidenceLocations);
                setViolations(data.lobs.personalUmbrella.chargeableIncidents.violations);
            }
        }
    };

    const getAndSetCompanyUseBySubmissionNumber = (submissionNumber) => {
        if (_.isEmpty(losses)) {
            const promise = MLRiskAnalysisService.getRACompanyUseMLByJobNumber(submissionNumber, authHeader);
            promise.then((data) => {
                updateCompanyUse(data);
            });
        }
    };

    const getAndSetCompanyUseByPolicyNumber = (policyNumber) => {
        const promise = MLRiskAnalysisService.getRACompanyUseDetailsMLByPolicyNumber(policyNumber, authHeader);
        promise.then((data) => {
            updateCompanyUse(data);
        });
    };

    const updateIsUserGCSServicing = () => {
        UserService.getCurrentUser(authHeader).then((aUser)=> {
            setIsGCSServicing(aUser.isGCSServicing);
        });
    };

    useEffect(() => {
        if (isQuote) {
            getAndSetCompanyUseBySubmissionNumber(jobOrPolicyNumber);
        } else if (isPolicy) {
            getAndSetCompanyUseByPolicyNumber(jobOrPolicyNumber);
        }
        updateIsUserGCSServicing();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getGaragingLocationsOverrides = () => {
        const formatGaragingLocationData = (location) => {
            let data = [
                {
                    header: messages.garagingLocation,
                    value: location.locationAddress
                },
                {
                    header: messages.county,
                    value: location.county
                },
                {
                    header: messages.taxTown,
                    value: location.taxTown
                },
                {
                    header: messages.territory,
                    value: location.territory
                }
            ]

            if (location.acrossStreetTerritory) {
                data = [
                    ...data,
                    {
                        header: messages.acrossStreetTerritory,
                        value: location.acrossStreetTerritory
                    }
                ]
            }
            return data;
        }

        const getCellGaragingLocationHeader = (rowData) => {
            return <strong>{translator(rowData.header)}</strong>;
        }

        const getCellGaragingLocationValue = (rowData) => {
            return rowData.value;
        }

        const overrides = garagingLocations.map((location, index) => {
            return {
                [`garagingLocationTable${index}`]: {
                    data: formatGaragingLocationData(location)
                },
                [`garagingLocationHeaderColumn${index}`]: {
                    renderCell: getCellGaragingLocationHeader
                },
                [`garagingLocationValueColumn${index}`]: {
                    renderCell: getCellGaragingLocationValue
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

  const getSignalGroupInfoOverrides = () => {
    const formatSignalGroupInformationData = (signalRecords) => {
      let data = [
        {
          header: messages.priorUBIScoreGroup,
          value: signalRecords.priorUBIRatedScoreGroup,
        },
        {
          header: messages.ratedUBIScoreGroup,
          value: signalRecords.currentUBIRatedScoreGroup,
        },
        {
          header: messages.participationGroup,
          value: signalRecords.participationGroup,
        },
        {
          header: messages.estimatedSignalPercentage,
          value: signalRecords.signalPercentage,
        },
      ];

      return data;
    };

    const getCellSignalGroupInformationValue = (rowData) => {
      return rowData.value;
    };

    const getCellSignalHeader = (rowData) => {
      return <strong>{translator(rowData.header)}</strong>;
    };

    const overrides = signalRecords.map((records, index) => {
      return {
        [`signalGroupInformationTable${index}`]: {
          data: formatSignalGroupInformationData(records),
        },
        [`signalHeaderColumn${index}`]: {
          renderCell: getCellSignalHeader,
        },
        [`signalGroupInformationValueColumn${index}`]: {
          renderCell: getCellSignalGroupInformationValue,
        },
        signalGroupInformationTable: {
          data: formatSignalGroupInformationData(signalRecords),
        },
        signalGroupInformationValueColumn: {
          renderCell: getCellSignalGroupInformationValue,
        },
      };
    });

    return Object.assign({}, ...overrides);
  };
    const getHoLocationInfoTableOverrides = () => {
        const formatLocationInfoData = (hoLocationInfo) => {
            return [
                {
                    header: messages.county,
                    value: hoLocationInfo.county
                },
                {
                    header: messages.taxTown,
                    value: hoLocationInfo.taxTown
                }
            ];
        };

        const getCellLocationInfoHeader = (rowData) => {
            return translator(rowData.header);
        }

        const getCellLocationInfoValue = (rowData) => {
            return rowData.value;
        }

        const overrides = {
            hoLocationInfoTable: {
                data: formatLocationInfoData(locationInfo)
            },
            hoLocationInfoHeaderColumn: {
                renderCell: getCellLocationInfoHeader
            },
            hoLocationInfoValueColumn: {
                renderCell: getCellLocationInfoValue
            }
        }

        return overrides;
    }

    const getPrimaryResidencesOverrides = () => {
        const formatPrimaryResidenceData = (residence) => {
            return [
                {
                    header: messages.primaryResidence,
                    value: residence.locationAddress
                },
                {
                    header: messages.county,
                    value: residence.county
                },
                {
                    header: messages.taxTown,
                    value: residence.taxTown
                },
                {
                    header: messages.territory,
                    value: residence.territory
                }
            ];
        }

        const getCellPrimaryResidenceHeader = (rowData) => {
            return translator(rowData.header);
        }

        const getCellPrimaryResidenceValue = (rowData) => {
            return rowData.value;
        }

        const overrides = primaryResidences.map((residence, index) => {
            return {
                [`primaryResidenceTable${index}`]: {
                    data: formatPrimaryResidenceData(residence)
                },
                [`primaryResidenceHeaderColumn${index}`]: {
                    renderCell: getCellPrimaryResidenceHeader
                },
                [`primaryResidenceValueColumn${index}`]: {
                    renderCell: getCellPrimaryResidenceValue
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const getVehicleSymbolsTableOverrides = () => {
        const getCellVehicleYearMakeModel = (rowData) => {
            return `${rowData.vehicle.year} ${rowData.vehicle.make} ${rowData.vehicle.model}`;
        };

        const getCellCompSymbol = (rowData) => {
            return rowData.compSymbol;
        };

        const getCellCollSymbol = (rowData) => {
            return rowData.collSymbol;
        }

        const overrides = {
            vehicleSymbolsTable: {
                data: vehicleSymbols
            },
            vehicleYearMakeModelColumn: {
                renderCell: getCellVehicleYearMakeModel
            },
            compSymbolColumn: {
                renderCell: getCellCompSymbol
            },
            collSymbolColumn: {
                renderCell: getCellCollSymbol
            }
        }

        return overrides;
    };

    const getConnectedCarTableOverrides = () => {
        const getCellVehicleType = (rowData) => {
            return rowData.vehicleBasicInfoML;
        };

        const getCellVin = (rowData) => {
            return rowData.vin;
        };

        const getCellCCEnrollmentDate = (rowData) => {
            return rowData.enrollmentDate
                ? <DateValue displayFormat="vshort" tag="span" value={rowData.enrollmentDate} />
                : undefined;
        };

        const getCellCCEnrollmentStatus = (rowData) => {
            return rowData.enrollmentStatus;
        };

        const overrides = {
            connectedCarTable: {
                data: connectedCar,
                title: messages.connectedCar
            },
            vehicleTypeColumn: {
                renderCell: getCellVehicleType
            },
            vinColumn: {
                renderCell: getCellVin
            },
            ccEnrollmentDateColumn: {
                renderCell: getCellCCEnrollmentDate
            },
            ccEnrollmentStatusColumn: {
                renderCell: getCellCCEnrollmentStatus
            }
        }

        return overrides;
    };

    const getSignalTableOverrides = () => {
        const getCellDriverName = (rowData) => {
            return rowData.driverName;
        };

        const getCellDriverDob = (rowData) => {
            return rowData.driverDob
                ? <DateValue displayFormat="vshort" tag="span" value={rowData.driverDob} />
                : undefined;
        };

        const getCellPhoneNumber = (rowData) => {
            return rowData.cellPhone;
        }

        const getCellEnrollmentDate = (rowData) => {
            return rowData.enrollmentDate
                ? <DateValue displayFormat="vshort" tag="span" value={rowData.enrollmentDate} />
                : undefined;
        }

        const getCellEnrollmentStatus = (rowData) => {
            return rowData.enrollmentStatus;
        }

        const getCellScore = (rowData) => {
            return rowData.score;
        }

        const getCellScoreDate = (rowData) => {
            return rowData.scoreDate
                ? <DateValue displayFormat="vshort" tag="span" value={rowData.scoreDate} />
                : undefined;
        }

        const getCellLastErrorMessage = (rowData) => {
            return rowData.lastErrorMessage;
        }

        const getCellDaysInactive = (rowData) => {
            return rowData.daysInactive;
        }    
        const overrides = {
            signalTable: {
                data: signalRecords,
                title: messages.signal
            },
            driverNameColumn: {
                renderCell: getCellDriverName
            },
            driverDobColumn: {
                renderCell: getCellDriverDob
            },
            cellPhoneColumn: {
                renderCell: getCellPhoneNumber
            },
            enrollmentDateColumn: {
                renderCell: getCellEnrollmentDate
            },
            enrollmentStatusColumn: {
                renderCell: getCellEnrollmentStatus
            },
            scoreColumn: {
                renderCell: getCellScore
            },
            scoreDateColumn: {
                renderCell: getCellScoreDate
            },
            lastErrorMessageColumn: {
                renderCell: getCellLastErrorMessage,
                visible:!isModernProductPersonalAuto
            },
            daysInactiveColumn: {
                renderCell: getCellDaysInactive,
                visible:isModernProductPersonalAuto
            }, 
        }

        return overrides;
    }

    const getHazardInformationTableOverrides = () => {
        const formatHazardInfoData = (hoHazardInfo) => {
            let data = [
                {
                    header: messages.geoProtect,
                    value: hoHazardInfo.geoProtectCode
                }
            ];

            if (hoHazardInfo.fireSubscriptionIndicator === 'Y') {
                data = [
                    {
                        header: messages.fireSubscriptionIndicator,
                        value: fireSubscriptionIndicator
                    },
                    ...data
                ];
            };

            if (hoHazardInfo.texasWindProtection) {
                data = [
                    ...data,
                    {
                        header: messages.texasWindInspection,
                        value: hoHazardInfo.texasWindProtection
                    }
                ];
            }

            return data;
        };

        const getCellHazardInfoHeader = (rowData) => {
            return translator(rowData.header);
        }

        const getCellHazardInfoValue = (rowData) => {
            return rowData.value;
        }

        const overrides = {
            hazardInformationTable: {
                data: formatHazardInfoData(hazardInfo),
                title: messages.hazardInformation
            },
            hazardInformationHeaderColumn: {
                renderCell: getCellHazardInfoHeader
            },
            hazardInformationValueColumn: {
                renderCell: getCellHazardInfoValue
            }
        }

        return overrides;
    }

    const getRiskEligibilityTableOverrides = () => {
        const formatRiskEligibilityData = (riskEligibility) => {
            let data = []
            if (isModernProduct && isHomeOwners) {
                data = [
                    {
                        header: messages.windHailRiskGroup,
                        value: riskEligibility.windHailRiskGroup
                    },
                    {
                        header: messages.wildFireRiskGroup,
                        value: riskEligibility.wildFireRiskGroup
                    },
                ]
            }
            else {
                data = [
                    {
                        header: messages.windHailRiskGroup,
                        value: riskEligibility.windHailRiskGroup
                    },
                    {
                        header: messages.wildFireRiskGroup,
                        value: riskEligibility.wildFireRiskGroup
                    },
                    {
                        header: messages.brushFireScore,
                        value: riskEligibility.brushFireScore
                    }
                ];
            }
            
            return data;
        };

        const getCellRiskEligibilityHeader = (rowData) => {
            return translator(rowData.header);
        }

        const getCellRiskEligibilityValue = (rowData) => {
            return rowData.value;
        }

        const overrides = {
            riskEligibilityTable: {
                data: formatRiskEligibilityData(riskEligibilityInfo),
                title: messages.riskEligibility
            },
            riskEligibilityHeaderColumn: {
                renderCell: getCellRiskEligibilityHeader
            },
            riskEligibilityValueColumn: {
                renderCell: getCellRiskEligibilityValue
            }
        }

        return overrides;
    }

    const getCoastalFloodingTableOverrides = () => {
        const formatCoastalFloodingData = (coastalFlooding) => {
            let data = [
                {
                    header: messages.proximityToTidalWater,
                    value: coastalFlooding.proximityToTidalWater
                },
                {
                    header: messages.inOutFloodZone,
                    value: coastalFlooding.inOutFloodZone
                }
            ];

            if (coastalFlooding.windBuildingZone) {
                data = [
                    ...data,
                    {
                        header: messages.windBuildingZone,
                        value: coastalFlooding.windBuildingZone
                    }
                ];
            };

            return data;
        };

        const getCellCoastalFloodingHeader = (rowData) => {
            return translator(rowData.header);
        }

        const getCellCoastalFloodingValue = (rowData) => {
            return rowData.value;
        }

        const overrides = {
            coastalFloodingTable: {
                data: formatCoastalFloodingData(coastalFloodingInfo),
                title: messages.coastalFlooding
            },
            coastalFloodingHeaderColumn: {
                renderCell: getCellCoastalFloodingHeader
            },
            coastalFloodingValueColumn: {
                renderCell: getCellCoastalFloodingValue
            }
        }

        return overrides;
    }

    const getPerilScoreInformationTableOverrides = () => {
        const formatPerilScoreInformationData = (perilScore) => {
            if (isModernProduct) {
                return [
                    {
                        header: messages.ratedProtectionClass,
                        value: perilScore.ratedProtetionClass
                    },
                    {
                        header: messages.matchUsing,
                        value: perilScore.matchUsing
                    },
                    {
                        header: messages.fireDistrict,
                        value: perilScore.fireDistrictName
                    },
                    {
                        header: messages.distanceToFireStationNp,
                        value: perilScore.distanceToFireStationNp
                    },
                    {
                        header: messages.hydrantWithIn1000ft,
                        value: perilScore.hydrantWithIn1000Feet === true ? "Yes" : perilScore.hydrantWithIn1000Feet === false ? "No" : perilScore.hydrantWithIn1000Feet
                    },
                    {
                        header: messages.protectionClassOverride,
                        value: perilScore.pPCOverrideDate
                    },
                    {
                        header: messages.alternatePPC,
                        value: perilScore.alternatePPC 
                    },

                ];
            }
            else {
                return [
                    {
                        header: messages.distanceToFireStation,
                        value: perilScore.distanceToFireStation
                    },
                    {
                        header: messages.protectionClassCode,
                        value: perilScore.protectionClassCode
                    },
                    {
                        header: messages.fireDistrict,
                        value: perilScore.fireDistrict
                    },
                    {
                        header: messages.locationFireScore,
                        value: perilScore.locationFireScore
                    }
                ];
            }
        };

        const getCellPerilScoreInformationHeader = (rowData) => {
            return translator(rowData.header);
        }

        const getCellPerilScoreInformationValue = (rowData) => {
            return rowData.value;
        }

        const overrides = {
            perilScoreInformationTable: {
                data: formatPerilScoreInformationData(perilScoreInfo),
                title: isModernProduct ? messages.publicProtectionClass : messages.perilScoreInformation
            },
            perilScoreInformationHeaderColumn: {
                renderCell: getCellPerilScoreInformationHeader
            },
            perilScoreInformationValueColumn: {
                renderCell: getCellPerilScoreInformationValue
            }
        }

        return overrides;
    }

    const openClaimDetails = (loss) => {
        loss.isAutoClaim = loss.claimLob === 'Auto';
        loss.isHomeClaim = loss.claimLob === 'Home';

        const getAutoLossDetailsOverrides = (lossDetails) => {
            const formatAutoLossDetailsData = (details) => {
                return [
                    {
                        header: messages.driversName,
                        value: details.driverName
                    },
                    {
                        header: messages.dateOfBirth,
                        value: <DateValue displayFormat="vshort" value={lossDetails.dateOfBirth} />
                    },
                    {
                        header: messages.gender,
                        value: details.gender
                    },
                    {
                        header: messages.licenseNumber,
                        value: details.licenseNumber
                    },
                    {
                        header: messages.licenseState,
                        value: details.licenseState
                    },
                    {
                        header: messages.year,
                        value: details.vehicle.year
                    },
                    {
                        header: messages.make,
                        value: details.vehicle.make
                    },
                    {
                        header: messages.model,
                        value: details.vehicle.model
                    },
                    {
                        header: messages.vin,
                        value: details.vehicle.vin
                    },
                    {
                        header: messages.vehicleDisposition,
                        value: details.vehicle.disposition
                    }
                ];
            };

            const getCellAutoLossDetailsHeader = (rowData) => {
                return <strong>{translator(rowData.header)}</strong>;
            };

            const getCellAutoLossDetailsValue = (rowData) => {
                return rowData.value;
            };

            const getCellType = (rowData) => {
                return rowData.type;
            };

            const getCellAmountPaid = (rowData) => {
                return rowData.amountPaid
                    ? <CurrencyValue showFractions currency={rowData.amountPaid.currency} value={rowData.amountPaid.amount} />
                    : undefined;
            };

            const getCellStatus = (rowData) => {
                return rowData.status;
            };


            const overrides = lossDetails.map((details, index) => {
                return {
                    [`autoLossDetailsTable${index}`]: {
                        data: formatAutoLossDetailsData(details)
                    },
                    [`autoLossDetailsHeaderColumn${index}`]: {
                        renderCell: getCellAutoLossDetailsHeader
                    },
                    [`autoLossDetailsValueColumn${index}`]: {
                        renderCell: getCellAutoLossDetailsValue
                    },
                    [`autoLossDetailsCoveragesTable${index}`]: {
                        data: details.coverages
                    },
                    [`autoLossDetailsCoverageTypeColumn${index}`]: {
                        renderCell: getCellType
                    },
                    [`autoLossDetailsCoverageAmountPaidColumn${index}`]: {
                        renderCell: getCellAmountPaid
                    },
                    [`autoLossDetailsCoverageStatusColumn${index}`]: {
                        renderCell: getCellStatus
                    }
                };
            });

            return Object.assign({}, ...overrides);
        };

        const getHomeLossDetailsOverrides = (lossDetails) => {
            const getCellHomeLossDetailsHeader = (rowData) => {
                return translator(rowData.header);
            };

            const getCellHomeLossDetailsValue = (rowData) => {
                return rowData.value;
            };

            const formatHomeLossDetailsData = (details) => {
                return [
                    {
                        header: messages.name,
                        value: details.name
                    },
                    {
                        header: messages.description,
                        value: details.description
                    },
                    {
                        header: messages.actOfGod,
                        value: details.actOfGod
                    },
                    {
                        header: messages.catIndicator,
                        value: details.catastropheInd
                    },
                    {
                        header: messages.COVERAGE_TYPE,
                        value: details.perilCategory
                    },
                    {
                        header: messages.AMOUNT_PAID,
                        value: details.amountPaid
                            ? <CurrencyValue showFractions currency={details.amountPaid.currency} value={details.amountPaid.amount} />
                            : undefined,
                    },
                    {
                        header: messages.STATUS,
                        value: details.status
                    }
                ];
            };

            const overrides = lossDetails.map((details, index) => {
                return {
                    [`homeLossDetailsTable${index}`]: {
                        data: formatHomeLossDetailsData(details),
                    },
                    [`homeLossDetailsHeaderColumn${index}`]: {
                        renderCell: getCellHomeLossDetailsHeader
                    },
                    [`homeLossDetailsValueColumn${index}`]: {
                        renderCell: getCellHomeLossDetailsValue
                    }
                }
            });

            return Object.assign({}, ...overrides);
        };

        let overrides = {
            autoLossDetailsContainer: {
                visible: loss.isAutoClaim
            },
            homeLossDetailsContainer: {
                visible: loss.isHomeClaim
            }
        };

        if (loss.isAutoClaim) {
            overrides = {
                ...overrides,
                autoLossDetailsIterable: {
                    data: loss.lossDetails
                },
                ...getAutoLossDetailsOverrides(loss.lossDetails)
            }
        } else if (loss.isHomeClaim) {
            overrides = {
                ...overrides,
                homeLossDetailsIterable: {
                    data: loss.lossDetails
                },
                ...getHomeLossDetailsOverrides(loss.lossDetails)
            }
        }

        const componentProps = {
            title: messages.claimDetails,
            uiProps: MLRatingFactorCompanyUseClaimDetailsPopupMetadata.pageContent,
            cancelBtnLabel: messages.close,
            modalBodyStyles: styles,
            getOverrideProps: () => {
                return overrides;
            }
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );

    }

    const getHoLossesTableOverrides = () => {
        const getCellClaimDate = (rowData) => {
            // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            <a onClick={() => openClaimDetails(rowData)}>
                <DateValue displayFormat="vshort" tag="span" value={rowData.claimDate} />
            </a>
        };

        const getCellTotalAmountPaid = (rowData) => {
            return rowData.totalAmountPaid
                ? <CurrencyValue showFractions currency={rowData.totalAmountPaid.currency} value={rowData.totalAmountPaid.amount} />
                : undefined;
        };

        const getCellDescription = (rowData) => {
            return rowData.description;
        }

        const overrides = {
            hoLossesTable: {
                data: losses
            },
            hoClaimDateColumn: {
                renderCell: getCellClaimDate
            },
            hoTotalAmountPaidColumn: {
                renderCell: getCellTotalAmountPaid
            },
            hoDescriptionColumn: {
                renderCell: getCellDescription
            }
        }

        return overrides;
    };

    const getPaLossesTableOverrides = () => {
        const getCellClaimDate = (rowData) => {
            // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            <a onClick={() => openClaimDetails(rowData)}>
                <DateValue displayFormat="vshort" tag="span" value={rowData.claimDate} />
            </a>
        };

        const getCellTotalAmountPaid = (rowData) => {
            return rowData.totalAmountPaid
                ? <CurrencyValue showFractions currency={rowData.totalAmountPaid.currency} value={rowData.totalAmountPaid.amount} />
                : undefined;
        };

        const getCellVehicleOperator = (rowData) => {
            return <strong>{rowData.vehicleOperator}</strong>;
        };

        const getCellDescription = (rowData) => {
            return rowData.description;
        }

        const overrides = {
            paLossesTable: {
                data: losses
            },
            paClaimDateColumn: {
                renderCell: getCellClaimDate
            },
            paTotalAmountPaidColumn: {
                renderCell: getCellTotalAmountPaid
            },
            paVehicleOperatorColumn: {
                renderCell: getCellVehicleOperator
            },
            paDescriptionColumn: {
                renderCell: getCellDescription
            }
        }

        return overrides;
    };

    const getPupLossesTableOverrides = () => {
        const getCellClaimDate = (rowData) => {
            return (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                <a onClick={() => openClaimDetails(rowData)}>
                    <DateValue displayFormat="vshort" tag="span" value={rowData.claimDate} />
                </a>
            );
        };

        const getCellTotalAmountPaid = (rowData) => {
            return rowData.totalAmountPaid
                ? <CurrencyValue showFractions currency={rowData.totalAmountPaid.currency} value={rowData.totalAmountPaid.amount} />
                : undefined;
        };

        const getCellVehicleOperator = (rowData) => {
            return <strong>{rowData.vehicleOperator}</strong>;
        };

        const getCellDescription = (rowData) => {
            return rowData.description;
        };

        const getCellClaimLob = (rowData) => {
            return rowData.claimLob
        }

        const overrides = {
            pupLossesTable: {
                data: losses
            },
            pupClaimDateColumn: {
                renderCell: getCellClaimDate
            },
            pupTotalAmountPaidColumn: {
                renderCell: getCellTotalAmountPaid
            },
            pupVehicleOperatorColumn: {
                renderCell: getCellVehicleOperator
            },
            pupDescriptionColumn: {
                renderCell: getCellDescription
            },
            pupClaimLobColumn: {
                renderCell: getCellClaimLob
            }
        }

        return overrides;
    };

    const getViolationsTableOverrides = () => {
        const getCellIncidentDate = (rowData) => {
            return <DateValue displayFormat="vshort" value={rowData.incidentDate} />;
        };

        const getCellConvictionDate = (rowData) => {
            return <DateValue displayFormat="vshort" value={rowData.convictionDate} />;
        };

        const getCellIncidentType = (rowData) => {
            return rowData.incidentType;
        };

        const getCellVehicleOperator = (rowData) => {
            return <strong>{rowData.vehicleOperator}</strong>;
        };

        const getCellDescription = (rowData) => {
            return rowData.description;
        };

        const overrides = {
            violationsTable: {
                data: violations
            },
            incidentDateColumn: {
                renderCell: getCellIncidentDate
            },
            convictionDateColumn: {
                renderCell: getCellConvictionDate
            },
            incidentTypeColumn: {
                renderCell: getCellIncidentType
            },
            mvrVehicleOperatorColumn: {
                renderCell: getCellVehicleOperator
            },
            mvrDescriptionColumn: {
                renderCell: getCellDescription
            }
        }

        return overrides;
    };

    const getRateCappingTableOverrides = () => {
        const formatRateCappingData = (rateCapping) => {
            return [
                {
                    header: messages.cappingInEffect,
                    value: rateCapping.isCappingInEffect ? getYesNo(rateCapping.isCappingInEffect) : undefined
                },
                {
                    header: messages.cappingType,
                    value: rateCapping.cappingType ? getTypeKeyDescription(CAPPINGTYPE_TYPELIST.getCode(rateCapping.cappingType).name) : undefined
                },
                {
                    header: messages.perilCapped,
                    value: rateCapping.perilCapped ? getTypeKeyDescription(PERILCAPPED_TYPELIST.getCode(rateCapping.perilCapped).name) : undefined
                }
            ];
        };

        const getCellRateCappingHeader = (rowData) => {
            return translator(rowData.header);
        }

        const getCellRateCappingValue = (rowData) => {
            return rowData.value;
        }

        const overrides = {
            rateCappingTable: {
                data: formatRateCappingData(!_.isEmpty(rateCappingDetails) ? rateCappingDetails : {}),
                title: messages.rateCapping
            },
            rateCappingHeaderColumn: {
                renderCell: getCellRateCappingHeader
            },
            rateCappingValueColumn: {
                renderCell: getCellRateCappingValue
            }
        }

        return overrides;
    }

    const getBookRollTableOverrides = () => {
        const getCellBookRollIndicator = (rowData) => {
            if (rowData) {
                return getTypeKeyDescription(BOOKROLLINDICATOR_TYPELIST.getCode(rowData).name)
            }
            return undefined;
        };

        const overrides = {
            bookRollTable: {
                data: !_.isNil(bookRollInd) ? [bookRollInd] : []
            },
            bookRollIndicatorColumn: {
                renderCell: getCellBookRollIndicator
            },
        };

        return overrides;
    }

    const getServiceLevelInformationTableOverrides = () => {
        const getCellLevel = (rowData) => {
            return rowData.level;
        };

        const getCellCount = (rowData) => {
            return rowData.count;
        };

        const overrides = {
            serviceLevelInformationTable: {
                data: !_.isEmpty(serviceLevelInfo) ? [serviceLevelInfo] : [],
                title: messages.serviceLevelInformation
            },
            serviceLevelColumn: {
                renderCell: getCellLevel
            },
            serviceCountColumn: {
                renderCell: getCellCount
            }
        }

        return overrides;
    }

    const getUniqueSignalRecordsByScoreAndDate = (signalRecords = []) => {
        if (!Array.isArray(signalRecords)) {
            return [];
        }

        const processedScoreDateKeys = new Set();

        return signalRecords.filter((signalRecord) => {
            const signalScore = signalRecord?.score ?? '';
            const signalScoreDate = signalRecord?.scoreDate ?? '';
            const scoreDateUniqueKey = `${signalScore}_${signalScoreDate}`;

            if (processedScoreDateKeys.has(scoreDateUniqueKey)) {
                return false;
            }

            processedScoreDateKeys.add(scoreDateUniqueKey);
            return true;
        });
    };

    const redirectToVeracity = () => {
        window.open(veracityUrl, '_blank');
    };

    const overrideProps = {
        vehicleSymbolsNPContent:{
           visible:isModernProductAuto && vehicleSymbolsNP.length>0,
           data:vehicleSymbolsNP,
           className:styles.symbolContainer
        },
        vehicleSymbolsHeaderNp:{
            visible:isModernProductAuto
        },
        paLocationInfoContainer: {
            visible: isPersonalAuto
        },
        garagingLocationsIterable: {
            data: garagingLocations
        },
        hoLocationInfoContainer: {
            visible: isHomeOwners
        },
        pupLocationInfoContainer: {
            visible: isPersonalUmbrella
        },
        primaryResidencesIterable: {
            data: primaryResidences
        },
        vehicleSymbolsContainer: {
            visible: isPersonalAuto && !isModernProductAuto
        },
        discountsContainer: {
            visible: isPersonalAuto
        },
        hazardInformationContainer: {
            visible: isHomeOwners
        },
        riskEligibilityContainer: {
            visible: isHomeOwners && !_.isEmpty(riskEligibilityInfo)
        },
        coastalFloodingContainer: {
            visible: isHomeOwners
        },
        perilScoreInformationContainer: {
            visible: isHomeOwners
        },
        hoLossesContainer: {
            visible: isHomeOwners
        },
        paLossesContainer: {
            visible: isPersonalAuto
        },
        pupLossesContainer: {
            visible: isPersonalUmbrella
        },
        violationsContainer: {
            visible: !isHomeOwners
        },
        rateCappingContainer: {
            visible: isGCSServicing
        },
        customerDocumentsContainer: {
            visible: isPersonalAuto && !_.isNil(veracityUrl)
        },
        serviceLevelInformationContainer: {
            visible: isGCSServicing
        },
        signalGroupInfoIterable:{
            data: getUniqueSignalRecordsByScoreAndDate(signalRecords)
        },
        paSignalGroupInformationContainer:{
            visible:isModernProductPersonalAuto
        },
        ...getHoLocationInfoTableOverrides(),
        ...getGaragingLocationsOverrides(),
        ...getSignalGroupInfoOverrides(),
        ...getPrimaryResidencesOverrides(),
        ...getVehicleSymbolsTableOverrides(),
        ...getConnectedCarTableOverrides(),
        ...getSignalTableOverrides(),
        ...getHazardInformationTableOverrides(),
        ...getRiskEligibilityTableOverrides(),
        ...getCoastalFloodingTableOverrides(),
        ...getPerilScoreInformationTableOverrides(),
        ...getHoLossesTableOverrides(),
        ...getPaLossesTableOverrides(),
        ...getPupLossesTableOverrides(),
        ...getViolationsTableOverrides(),
        ...getRateCappingTableOverrides(),
        ...getBookRollTableOverrides(),
        ...getServiceLevelInformationTableOverrides()
    }

    const resolvers = {
        resolveCallbackMap: {
            redirectToVeracity
        },
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    )
};

MLRatingFactorCompanyUseComponent.propTypes = {
    riskAnalysisType: PropTypes.func.isRequired,
    quoteId: PropTypes.string.isRequired,
    isQuote: PropTypes.bool.isRequired,
    isPolicy: PropTypes.bool.isRequired,
    isPersonalAuto: PropTypes.bool,
    isPersonalUmbrella: PropTypes.bool,
    isHomeOwners: PropTypes.bool,
    styles: PropTypes.arrayOf(PropTypes.shape({}))
};

MLRatingFactorCompanyUseComponent.defaultProps = {
    isPersonalAuto: false,
    isPersonalUmbrella: false,
    isHomeOwners: false,
    styles: undefined
}

export default MLRatingFactorCompanyUseComponent;